export default "__VITE_ASSET__BhYFv$cN__"